import React from "react";
import { useState } from "react";
import Icon from "../Icon";
import defaultProfilePicture from "assets/images/default-profile-picture.png";

function ProfileCard({ value, onChange, name, readonly }) {
    const defaultImage = defaultProfilePicture;
    const [imageUrl, setImageUrl] = useState(value ? (typeof value === "string" ? value : URL.createObjectURL(value)) : defaultImage);

    function onChangeHandler({ target: { files } }) {
        const val = files[0];
        if (val) {
            setImageUrl(URL.createObjectURL(val));
            onChange(val);
        }
    }

    return (
        <div className="profile-card">
            <div className="card">
                <img src={imageUrl || defaultImage} alt="ProfilePhoto" style={{ width: "100%", borderRadius: "50%" }} />
                {!readonly && (
                    <>
                        <div className="input-file-container">
                            <input
                                className="input-file"
                                id={name}
                                type="file"
                                onChange={onChangeHandler}
                                title=""
                                accept=".jpg,.jpeg,.png"
                            />
                            <label tabIndex="0" htmlFor={name} className="input-file-trigger">
                                <Icon name="add-photo" size="md" color="white" />
                                Select an Image
                            </label>
                        </div>
                        <p className="file-return"></p>
                    </>
                )}
            </div>
        </div>
    );
}

export default ProfileCard;
